













































































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useRouter, useFormat } from 'vivat';
import PrettyCheck from 'pretty-checkbox-vue/check';

import CommonIconTop from '@/components/CommonIconTop.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import cashFlowOptions from '@/table/cashFlow/cashFlowList';

import getCashFlows from '@/gql/cashflow/getCashFlows.gql';
import updateCashflow from '@/gql/cashflow/updateCashflow.gql';
import getCashFlowStats from '@/gql/cashflow/getCashFlowStats.gql';
import batchUpdateCashflow from '@/gql/cashflow/batchUpdateCashflow.gql';

const CashFlowList = defineComponent({
  components: {
    CommonIconTop,
    CommonModalWithPreset,
    PrettyCheck,
  },
  setup() {
    // const { router } = useRouter();
    const toCurrency = (str: string | number) => useFormat.number(str).currency();
    const toCommaFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const colorIndex = ref(0);
    const COLORS = ['pink', 'green', 'blue', 'yellow', 'red', 'gray', 'orange', 'teal', 'indigo', 'purple'];
    const forceReload: Ref<boolean> = ref(true);
    const filter = reactive({
      status: '',
      name: '',
      date: {
        from: undefined,
        to: undefined,
      },
    });
    function clickDateHandler(date: any) {
      if (filter.date.from === useFormat.date(date).computerShortDate()) {
        filter.date = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.date = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
    }

    const cashFlowsVariable = computed(() => {
      const vars: {[key: string]: any} = {
        filterStatus: undefined,
        filter: undefined,
        filterDateBetween: filter.date.from ? filter.date : undefined,
      };
      if (filter.status) {
        vars.filterStatus = filter.status;
      }
      if (filter.name) {
        vars.filter = {
          AND: [
            { column: 'NAME', operator: 'LIKE', value: `%${filter.name}%` },
          ],
        };
      }
      return vars;
    });

    const { result: cashFlowStatsResult, loading: cashflowStatsLoading } = useQuery(getCashFlowStats, () => ({ fetchPolicy: 'network-only' }));
    const cashFlowStats = useResult(cashFlowStatsResult, {
      monthlySum: 0,
      pendingSum: 0,
      monthlyPaidSum: 0,
      countByCategories: [],
      sumByMonths: [],
      countExpense: { paginatorInfo: { total: 0 } },
      countIncome: { paginatorInfo: { total: 0 } },
    }, (data: any) => ({
      ...data.cashFlowStats,
      countByCategories: data.cashFlowStats.countByCategories.map((category: { data: number; name: string }) => {
        if (colorIndex.value === 9) colorIndex.value = 0;
        else colorIndex.value += 1;
        return {
          ...category,
          color: COLORS[colorIndex.value],
        };
      }),
      countExpense: data.countExpense.paginatorInfo.total,
      countIncome: data.countIncome.paginatorInfo.total,
      countAll: data.countIncome.paginatorInfo.total,
    }));

    const totalExpense = computed(() => {
      let totalYearExpense = 0;
      cashFlowStats.value.sumByMonths.forEach((val: any) => {
        totalYearExpense += val.sum;
      });
      return totalYearExpense;
    });

    // Use to updateCashFlowStatus
    const confirmModal = ref(null);
    const pendingUpdateCashFlow = reactive({
      id: -1,
      status: 'PENDING',
    });
    const updateCashFlowStatusMutation = useMutation(updateCashflow, () => ({
      variables: {
        input: pendingUpdateCashFlow,
      },
      refetchQueries: ['getCashFlows', 'getCashFlowStats'],
    }));
    updateCashFlowStatusMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
      pendingUpdateCashFlow.id = -1;
    });
    function updateCashFlowStatusHandler(id: number, status: string) {
      pendingUpdateCashFlow.id = id;
      pendingUpdateCashFlow.status = status;
      updateCashFlowStatusMutation.mutate();
    }

    const selectedItemId: Ref<number[]> = ref([]);
    const pendingUpdateStatus: Ref<string> = ref('PENDING');
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }
    const batchUpdateCashFlowMutation = useMutation(batchUpdateCashflow, () => ({
      variables: {
        ids: selectedItemId.value,
        status: pendingUpdateStatus.value,
      },
      refetchQueries: ['getCashFlows', 'getCashFlowStats'],
    }));
    function updateCashFlowBatch(status: string) {
      pendingUpdateStatus.value = status;
      batchUpdateCashFlowMutation.mutate();
    }
    batchUpdateCashFlowMutation.onDone(() => {
      selectedItemId.value = [];
    });

    return {
      forceReload,

      // Cashflow Stats
      cashFlowStats,
      totalExpense,

      selectedItemId,
      selectItem,

      // Use with Table
      getCashFlows,
      cashFlowOptions,
      cashFlowsVariable,
      getCashFlowsResult: (data: any) => data.cashFlows,
      filter,
      clickDateHandler,

      toCurrency,
      toCommaFormat,

      // Use to update CashFlowStatus
      confirmModal,
      updateCashFlowStatusHandler,

      updateCashFlowBatch,
    };
  },
});

export default CashFlowList;
